import React from 'react'
import {MenuItem} from './MenuItem'
import {useIntl} from 'react-intl'

export function MenuInner() {
  const intl = useIntl()
  return (
    <>
      <MenuItem title={intl.formatMessage({id: 'MENU.HOME'})} to='/dashboard' />
      <MenuItem title={intl.formatMessage({id: 'MENU.GAMES'})} to='/games' />
      <MenuItem title={intl.formatMessage({id: 'MENU.COURSES'})} to='/courses' />
    </>
  )
}
